import { Action } from '@ngrx/store'
import { InvoiceTypes } from '@tokeet-frontend/invoices'
import { AccountRatesDialogTab } from '@tv3/containers/rates/account-rates-dialog/account-rates-dialog.component'
import {
  OpenAddBookingFormulaDialog,
  OpenAddChannelDialog,
  OpenAddChargeDialog,
  OpenAddCustomChannelDialog,
  OpenAddDataFeedDialog,
  OpenAddExpenseDialog,
  OpenAddExtraDialog,
  OpenAddGuestDialog,
  OpenAddHoldDialog,
  OpenAddInquiryOverlay,
  OpenAddInvoiceOverlay,
  OpenAddRateDialog,
  OpenAddRentalDialog,
  OpenAddRentalMiltiDialog,
  OpenAddRentalParentChildDialog,
  OpenAddTaskDialog,
  OpenAddTemplateDialog,
  OpenAddVendorDialog,
  OpenImportCalendarDialog,
  OpenBookingAutomationOverlay,
  OpenDocumentAutomationOverlay,
  OpenExpenseAutomationOverlay,
  OpenInvoiceAutomationOverlay,
  OpenReviewAutomationOverlay,
  OpenTaskAutomationOverlay,
  OpenMessageAutomationOverlay,
  OpenAddDocumentDialog,
  OpenAddEmailForwardingDialog,
  OpenLastMinuteAutomationDialog,
  OpenChannelAutomationDialog,
  OpenAddLosDiscountDialog,
  OpenAddDiscountCodeDialog,
  OpenMinStayAutomationDialog,
  OpenGapNightAutomationDialog,
  OpenRateAutomationDialog,
  OpenGroupRateDialog,
} from '@tv3/store/overlay/overlay.actions'
import { TemplateType } from '@tokeet-frontend/templates'
export interface UniversalPlusMenuItem {
  icon: string
  hoverIcon?: string
  label: string
  description: string
  bg?: string
  submenu?: UniversalPlusMenuItem[]
  open?: boolean
  //
  url?: string
  action?: Action
}

export const universalPlusMenu: UniversalPlusMenuItem[] = [
  {
    icon: 'cs-icon cs-icon-calendar-alt3 text-indigo text-xxxl fa-fw',
    bg: 'bg-secondary-indigo',
    label: 'Reservation & Guest Management',
    description: 'Create bookings, handle inquiries, hold dates, and add guest details',
    submenu: [
      {
        icon: 'cs-icon cs-icon-file-plus text-indigo text-xxxl fa-fw',
        label: 'Add Inquiry',
        description: 'Manually create a new  inquiry',
        url: '/inquiries/inbox',
        action: OpenAddInquiryOverlay({ params: {} }),
      },
      {
        icon: 'cs-icon cs-icon-calendar-plus4 text-success text-xxxl fa-fw',
        label: 'Add Booking',
        description: 'Manually create a new booking',
        url: '/inquiries/inbox',
        action: OpenAddInquiryOverlay({ params: { isBooking: true, title: $localize`Add Booking` } }),
      },
      {
        icon: 'cs-icon cs-icon-calendar-pause3 text-warning text-xxxl fa-fw',
        label: 'Add Hold Event',
        description: 'Block dates on your calendar and make them unavailable for booking.',
        url: '/calendar/hold',
        action: OpenAddHoldDialog({}),
      },
      {
        icon: 'cs-icon cs-icon-users text-secondary text-xxxl fa-fw',
        label: 'Add Guest',
        description: 'Manually add a new guest',
        url: '/guests',
        action: OpenAddGuestDialog(),
      },
    ],
  },
  {
    icon: 'cs-icon cs-icon-building-dollar text-info text-xxxl fa-fw',
    bg: 'bg-secondary-info',
    label: 'Property Setup',
    description: 'Add rentals, configure multi-unit listings, and organize parent-child property relationships.',
    submenu: [
      {
        icon: 'cs-icon cs-icon-buildings text-warning text-xxxl fa-fw',
        label: 'Add Rental',
        description: 'Manually add a new AdvanceCM rental',
        url: 'rentals',
        action: OpenAddRentalDialog(),
      },
      {
        icon: 'cs-icon cs-icon-building2 text-info text-xxxl fa-fw',
        label: 'Add Multi-Unit',
        description: 'Add multiple connected units under one property.',
        url: 'rentals',
        action: OpenAddRentalMiltiDialog(),
      },
      {
        icon: 'cs-icon cs-icon-parent-child2 text-success text-xxxl fa-fw',
        label: 'Add Parent/Child',
        description: 'Link related properties for better management.',
        url: 'rentals',
        action: OpenAddRentalParentChildDialog({}),
      },
    ],
  },
  {
    icon: 'cs-icon cs-icon-dollar-sync text-danger text-xxxl fa-fw',
    bg: 'bg-secondary-danger',
    label: 'Expenses, Tasks & Rates',
    description: 'Track costs, assign tasks, and set flexible rates for better financial and operational control',
    submenu: [
      {
        icon: 'cs-icon cs-icon-tasks text-info text-xxxl fa-fw',
        label: 'Add Task',
        description: 'Manually create a new task',
        url: '/tasks/list',
        action: OpenAddTaskDialog(),
      },
      {
        icon: 'cs-icon cs-icon-wallet2 text-warning text-xxxl fa-fw',
        label: 'Add Expense',
        description: 'Manually create a new expense',
        url: '/expenses',
        action: OpenAddExpenseDialog(),
      },
      {
        icon: 'cs-icon cs-icon-money-plus text-indigo text-xxxl fa-fw',
        label: 'Add Standard Rate',
        description: 'Set a fixed nightly price that remains constant over time.',
        url: '/calendar/multi',
        action: OpenAddRateDialog({ data: { type: 'standard' } }),
      },
      {
        icon: 'cs-icon cs-icon-dollar-sync text-danger text-xxxl fa-fw',
        label: 'Add Dynamic Rate',
        description: 'Dynamic rates auto-adjust with occupancy and update channels instantly.',
        url: '/calendar/multi',
        action: OpenAddRateDialog({ data: { type: 'dynamic' } }),
      },
      {
        icon: 'cs-icon cs-icon-building-dollar text-info text-xxxl fa-fw',
        label: 'Group Rates',
        description: 'Apply rate changes to multiple rentals at once.',
        url: '/calendar/multi',
        action: OpenGroupRateDialog({ data: { activeTab: AccountRatesDialogTab.GroupRates } }),
      },
    ],
  },
  {
    icon: 'cs-icon cs-icon-net-dollar text-warning text-xxxl fa-fw',
    bg: 'bg-secondary-warning',
    label: 'Channels & Calendar',
    description: 'Connect platforms, manage availability, and keep your bookings in sync effortlessly.',
    submenu: [
      {
        icon: 'cs-icon cs-icon-net-plus text-success text-xxxl fa-fw',
        label: 'Add Channel',
        description: 'Connect your rentals to major booking platforms.',
        url: '/channels',
        action: OpenAddChannelDialog(),
      },
      {
        icon: 'cs-icon cs-icon-plug2 text-warning text-xxxl fa-fw',
        label: 'Add Custom Channel',
        description: 'Integrate with a unique or private booking source.',
        url: '/channels',
        action: OpenAddCustomChannelDialog(),
      },
      {
        icon: 'cs-icon cs-icon-calendar-share2 text-info text-xxxl fa-fw',
        label: 'Import Calendar',
        description: 'Sync external iCal events with your calendar.',
        url: '/calendars',
        action: OpenImportCalendarDialog(),
      },
    ],
  },
  {
    icon: 'cs-icon cs-icon-ai text-success text-xxxl fa-fw',
    bg: 'bg-secondary-success',
    label: 'Automation',
    description: 'Set up smart automation to manage rates, bookings, messages, invoices, and tasks.',
    submenu: [
      {
        icon: 'cs-icon cs-icon-cog-back text-warning text-xxxl fa-fw',
        label: 'Add Automation',
        description: 'Streamline tasks with automated actions.',
        url: '/automations',
      },
      {
        icon: 'cs-icon cs-icon-time-counter2 text-danger text-xxxl fa-fw',
        label: 'Add Last Minute Automation',
        description: 'Modify pricing close to check-in.',
        url: '/automations',
        action: OpenLastMinuteAutomationDialog({}),
      },
      {
        icon: 'cs-icon cs-icon-net-dollar text-success text-xxxl fa-fw',
        label: 'Add Channel Rate Automation',
        description: 'Adjust and sync rates across platforms.',
        url: '/automations',
        action: OpenChannelAutomationDialog({}),
      },
      {
        icon: 'cs-icon cs-icon-calendar-sync2 text-info text-xxxl fa-fw',
        label: 'Add Booking Automation',
        description: 'Automate booking-related actions.',
        url: '/automations',
        action: OpenBookingAutomationOverlay(),
      },
      {
        icon: 'cs-icon cs-icon-building-dollar text-info text-xxxl fa-fw',
        label: 'Add Group Rates',
        description: 'Set bulk pricing for multiple rentals.',
        url: '/automations',
        action: OpenRateAutomationDialog({ data: { activeTab: AccountRatesDialogTab.GroupRates } }),
      },
      {
        icon: 'cs-icon cs-icon-sign2 text-danger text-xxxl fa-fw',
        label: 'Add New Document Automation',
        description: 'Auto-send contracts & agreements.',
        url: '/automations',
        action: OpenDocumentAutomationOverlay(),
      },
      {
        icon: 'cs-icon cs-icon-los-discount2 text-warning text-xxxl fa-fw',
        label: 'Add LOS Discount',
        description: 'Apply discounts based on length of stay.',
        url: '/automations',
        action: OpenAddLosDiscountDialog(),
      },
      {
        icon: 'cs-icon cs-icon-wallet2 text-indigo text-xxxl fa-fw',
        label: 'Add Expense Automation',
        description: 'Track and manage costs automatically.',
        url: '/automations',
        action: OpenExpenseAutomationOverlay(),
      },
      {
        icon: 'cs-icon cs-icon-discount-code2 text-indigo text-md',
        label: 'Add Discount Code',
        description: 'Offer special pricing with promo codes.',
        url: '/automations',
        action: OpenAddDiscountCodeDialog(),
      },
      {
        icon: 'cs-icon cs-icon-file-alt-dollar text-success text-xxxl fa-fw',
        label: 'Add Invoice Automation',
        description: 'Generate and send invoices seamlessly.',
        url: '/automations',
        action: OpenInvoiceAutomationOverlay(),
      },
      {
        icon: 'cs-icon cs-icon-bed2 text-danger text-xl',
        label: 'Add Min Night Stay',
        description: 'Set minimum stay requirements.',
        url: '/automations',
        action: OpenMinStayAutomationDialog({}),
      },
      {
        icon: 'cs-icon cs-icon-chat-sync text-primary text-xxxl fa-fw',
        label: 'Add Message Automation',
        description: 'Auto-send guest & staff communications.',
        url: '/automations',
        action: OpenMessageAutomationOverlay(),
      },
      {
        icon: 'cs-icon cs-icon-calendar-alt3 text-success text-xxxl fa-fw',
        label: 'Add Gap Night',
        description: 'Adjust pricing for unbooked gap nights',
        url: '/automations',
        action: OpenGapNightAutomationDialog({}),
      },
      {
        icon: 'cs-icon cs-icon-chats-star text-warning text-xxxl fa-fw',
        label: 'Add Review Automation',
        description: 'Automate guest review requests.',
        url: '/automations',
        action: OpenReviewAutomationOverlay(),
      },
      {
        icon: 'cs-icon cs-icon-calendar-dollar text-primary text-xxxl fa-fw',
        label: 'Add Dynamic Rate',
        description: 'Auto-adjust rates based on demand.',
        url: '/automations',
        action: OpenAddRateDialog({ data: { type: 'dynamic' } }),
      },
      {
        icon: 'cs-icon cs-icon-task-square text-danger text-xxxl fa-fw',
        label: 'Add Task Automation',
        description: 'Assign and manage tasks effortlessly.',
        url: '/automations',
        action: OpenTaskAutomationOverlay(),
      },
    ],
  },
  {
    icon: 'cs-icon cs-icon-card3 text-primary text-xxxl fa-fw',
    bg: 'bg-secondary-primary',
    label: 'Billing, Integration & Others',
    description: 'Handle invoices, payments, branding, templates, and vendor management seamlessly.',
    submenu: [
      {
        icon: 'cs-icon cs-icon-bill-plus text-info text-xxxl fa-fw',
        label: 'Add Invoice',
        description: 'Generate and manage invoices for payments.',
        url: '/invoices',
        action: OpenAddInvoiceOverlay({ data: { type: InvoiceTypes.BookingInvoice } }),
      },
      {
        icon: 'cs-icon cs-icon-content text-warning text-xxxl fa-fw',
        label: 'Add Template',
        description: 'Save reusable templates for emails or documents.',
        url: '/templates',
        action: OpenAddTemplateDialog({ data: { type: TemplateType.Email } }),
      },
      {
        icon: 'cs-icon cs-icon-dollar-circle-plus-circle text-indigo text-xxxl fa-fw',
        label: 'Add Charge',
        description: 'Apply additional charges to bookings.',
        url: '/charges',
        action: OpenAddChargeDialog(),
      },
      {
        icon: 'cs-icon cs-icon-color-cards text-info text-xxxl fa-fw',
        label: 'Add Branding Info',
        description: 'Customize branding for guest communications.',
        url: '/settings/branding',
      },
      {
        icon: 'cs-icon cs-icon-checklist-dollar-circle text-danger text-xxxl fa-fw',
        label: 'Add Extra',
        description: 'Offer add-ons like breakfast or cleaning services.',
        url: '/extras',
        action: OpenAddExtraDialog(),
      },
      {
        icon: 'cs-icon cs-icon-email-arrow-right text-success text-xxxl fa-fw',
        label: 'Add Email Forwarding',
        description: 'Auto-forward emails to your team.',
        url: '/settings/email',
        action: OpenAddEmailForwardingDialog(),
      },
      {
        icon: 'cs-icon cs-icon-calendar-dollar-circle text-success text-xxxl fa-fw',
        label: 'Add Booking Formulas',
        description: 'Customize pricing rules for bookings.',
        url: 'formulas',
        action: OpenAddBookingFormulaDialog({}),
      },
      {
        icon: 'cs-icon cs-icon-building-file-cycle text-indigo text-xxxl fa-fw',
        label: 'Add Data Feeds',
        description: 'Sync real-time data across platforms.',
        url: '/feeds',
        action: OpenAddDataFeedDialog(),
      },
      {
        icon: 'cs-icon cs-icon-los-discount2 text-warning text-xxxl fa-fw',
        label: 'Add Discounts',
        description: 'Set up promotional offers and discounts.',
        url: '/discounts',
      },
      {
        icon: 'cs-icon cs-icon-card-plus-circle text-info text-xxxl fa-fw',
        label: 'Add Payment Gateway',
        description: 'Connect payment processors for transactions.',
        url: '/payments/options',
      },
      {
        icon: 'cs-icon cs-icon-store text-primary text-xxxl fa-fw',
        label: 'Add Vendor',
        description: 'Register suppliers for services & inventory.',
        url: '/vendors',
        action: OpenAddVendorDialog(),
      },
      {
        icon: 'cs-icon cs-icon-smart-device2 text-danger text-xxxl fa-fw',
        label: 'Add Smart Device Provider',
        description: 'Integrate smart locks and devices.',
        url: '/devices',
      },
      {
        icon: 'cs-icon cs-icon-file-alt-plus text-indigo text-xxxl fa-fw',
        label: 'Add Document',
        description: 'Upload and manage rental agreements.',
        url: '/documents',
        action: OpenAddDocumentDialog(),
      },
    ],
  },
]
